import { Component, OnInit } from '@angular/core';
import { Yii } from "libraries/interfaces/Yii";
import { AppRootService } from "../app/shared/services/app-root/app-root-service";
import { HomeDomainService, IAppCard, IHomeApplication, IHomeConfig } from "./home-domain.service";
import { tap } from "rxjs/operators";

@Component({
    selector: 'home-app',
    template: `
        <div class="app-wrapper app-home">
            <div *ngIf="apps?.length && appCard" class="apps-container">
                <card *ngFor="let app of apps" class="app-card">
                    <div class="card-header-content">
                        <h1>
                            <fa-icon [icon]="app.icon | iconNameToDefinition"></fa-icon>
                            {{app.name}}
                        </h1>
                    </div>
                    <div class="card-body-content">
                        <div class="app-description">{{app.descriptionArray | localized}}</div>
                        <div class="app-links">
                            <a *ngFor="let link of appCard[app.code]"
                               [class]="link.code"
                               [routerLink]="link.url">
                                <fa-icon [icon]="link.icon"></fa-icon>
                                <span>{{link.text}}</span>
                            </a>
                        </div>
                    </div>
                </card>
            </div>
        </div>
    `,
    styles: [`
        .apps-container {
            display: flex;
            flex-wrap: wrap;
            margin-left: 15px;
        }

        .app-card {
            width: calc(50% - 15px);
            min-width: 400px;
            margin-right: 15px
        }
        
        h1 fa-icon{
            width: 30px;
            display: inline-block;
        }

        .card-body-content {
            padding: .75rem;
        }

        .app-links {
            margin: 1rem 0;
        }

        .app-links a {
            display: block;
            color: #337ab7;
            margin : .75rem;
        }
        .app-links a:hover {
            text-decoration: none;
        }
        .app-links a:hover span{
            text-decoration: underline;
        }

        .app-links a fa-icon {
            width: 20px;
            display: inline-block;
        }

        .
    `]
})
export class HomeComponent implements OnInit {
    public title: string = Yii.t('wui-home-js', 'Accueil');
    public apps: IHomeApplication[];

    public appCard: IAppCard;

    constructor(
        private readonly appRootService: AppRootService,
        private readonly homeDomainService: HomeDomainService,
    ) {
    }

    public setAppName(): void {
        sessionStorage.setItem('childAppName', 'home');
    }

    public ngOnInit(): void {
        this.homeDomainService.getConfig()
            .pipe(
                tap((): void => {
                    this.homeDomainService.getAppCard()
                        .subscribe((appCard: IAppCard): void => {
                            this.appCard = appCard;
                        });
                }),
            )
            .subscribe(
                (config: IHomeConfig): void => {
                    this.apps = config.applicationArray;
                    this.appRootService.setBrowserTitle(config.globalName);
                    this.appRootService.setCurrent('home');
                    this.setAppName();
                });
    }

}
